import { ReactNode } from "react";
import { MatchStatus } from "./Context";
import { ConstitutionStatusOption, OptionReasons } from "./models";
import { MultiValue } from "react-select";
import { NavigateFunction } from "react-router-dom";
import { Address } from "./Api";


export interface AppSettings {
    baseUrl: string
}

export type Option<T> = {
    value: T;
    label: string;
    hasDescription?: boolean
}


//Login

export type User = {
    id: string,
    firstName: string,
    lastName: string,
    password: string,
    confirmPassword?: string,
    email: string,
    Startup?: StartUp,
    Company?: Corporate,
    role?: StartUp | Corporate,
    department?: OptionTypes,
    jobTitle?: string,
    phoneNumber: string,
    startupId?: string,
    companyId?: string,
    departmentId?: string,
    levelId?: string,
    enabled?: boolean,
    level?: OptionTypes,
    tags?: OptionTypes[],
    reasons?: OptionReasons[],
    sectors?: OptionTypes[]
}

export const initialUser: User = {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: undefined,
    Startup: undefined,
    Company: undefined,
    role: undefined,
    department: undefined,
    jobTitle: undefined,
    phoneNumber: "",
}




// Register StartUp
export type GeneralInfo = {
    section1: string;
    section2: string;
    section3: string;
    terms: string;
    privacy: string;
}

export type UserInfo = {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    password: string;
    confirmPassword: string;
}

export type StartUpInfo = {
    startUpName: string;
    website: string;
    companyName: string;
    vatNumber: string;
    address: Address;
    city: OptionTypes;
    sdi: string;
    pec: string;
    state: ConstitutionStatusOption;
    sector: OptionTypes;
}

export type ResponseInfo = {
    option: OptionTypes;
    termsChecked: boolean;
    privacyChecked: boolean
}
// end Register StartUp

// Register corporate
export type UserCompanyInfo = {
    linkedInId: string;
    firstName: string;
    lastName: string;
    email: string;
    sectors: MultiValue<OptionTypes>;
    reasons: MultiValue<OptionTypes>;
    reasonsDescription?: string;
    reasonsHasDescription?: boolean;
    password: string;
    confirmPassword: string;
}

export interface Reasons extends OptionTypes {
    hasDescription: boolean
    id?: string,
    description?: string
}

export type CorporateInfo = {
    companyName: string;
    city: OptionTypes;
    department: OptionTypes;
    level: OptionTypes;
    jobTitle: string;
    termsChecked: boolean;
    privacyChecked: boolean
}

export type CorporateGuest = {
    firstName: string;
    lastName: string;
    email: string
    companyName: string;
    city: OptionTypes;
}


// end corporate register

export type LogInData = {
    user: string;
    password: string;
}

export type StartUp = {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    startUpName: string;
    companyName: string;
    state: OptionTypes;
    option: OptionTypes;
    image: string
    imageFile?: File | null
    logoFile?: File | null
    sector?: OptionTypes;
    id?: string
    name: string
    logoUrl?: string,
    coverUrl?: string,
    description?: string,
    sectorId?: string,
    vat?: string,
    address?: string,
    country?: OptionTypes,
    city?: OptionTypes,
    sdiPec?: string,
    pitch?: string,
    constitutionStatus?: OptionTypes,
    advVisibility?: true,
    currentPlan?: Plan,
    department?: OptionTypes;
    plan?: OptionTypes
    tags?: OptionTypes[];
    canMatch?: boolean;
    unmatchableReason?: string;
    currentCounter: CurrentCounter;
    reasons?: OptionReasons[],
    sectors?: OptionTypes[]
}

export type CurrentCounter = {
    id: string,
    startupId: string,
    month: number,
    year: number,
    availableMonthMatches: number,
    confirmedYearMeetings: number
}

export type OptionTypes = {
    id?: string
    value: string;
    label: string;

    htmlDescription?: string
    description?: string
}

export type Plan = {
    discountedPrice?: number,
    htmlDescription?: string,
    id: string,
    isCurrentPlan?: boolean,
    monthPrice?: number,
    title?: string,
    htmlRegisterText?: string,
    monthMatches?: number,
    yearMeetings?: number,
    visibility?: boolean,
    extraMeetingPrice?: string,
    yearPrice?: number,
    yearDiscountedPrice?: number,

}

// Corporates
export type Corporate = {
    id: string
    name: string,
    users?: CorporateUsers[]
    city: OptionTypes,
    countUserCompany?: number,
    reasons?: OptionReasons[],
    sectors?: OptionTypes[],
    tags?: OptionTypes[],
    industry?: OptionTypes
}

export interface CorporateUsers {
    value: string,
    label: string
    unmatchableReason: string,
    canMatch: boolean,
    level: string
}

export type Department = {
    id: string
    description: string

}

export type Role = {
    id: string
    name: string
    logoUrl?: string,
    coverUrl?: string,
    description?: string,
    sectorId?: string,
    vat?: string,
    address?: string,
    country?: string,
    city?: string,
    sdiPec?: string,
    pitch?: string,
    constitutionStatus?: string,
    advVisibility?: true,
    currentPlan?: string
}

export type Billing = {
    id?: string,
    advanceVisibility: string,
    planName: string,
    month: string,
    monthlyDirectContact: string,
    yearlyMeetings: string,
    year?: number,
    total?: number,
    doneMonthContact?: number,
    maxMonthContact?: number,
    doneYearMeeting?: number,
    maxYearlyMeeting?: number
}

export type Filter = {
    constitutionStatus?: OptionTypes[]
    departments?: OptionTypes[]
    sectors?: OptionTypes[]
    tags?: OptionTypes[]
    levels?: OptionTypes[],
}

export const ModalType = {
    info: "info",
    success: "success",
    error: "error",
    loading: "loading",
}

export type Modal = {
    isOpen: boolean,
    type: "info" | "error" | "success" | "loading" | string,
    title: string,
    message: string,
    onCloseNotAuthorized?: (navigate?: NavigateFunction, prevPath?: string, logout?: any) => void
    onCloseCallback?: () => void
}

export type ModalChildrenPar = {
    title?: string
    children?: ReactNode | null
    modalIsOpen?: boolean
    setModalIsOpen?: (param: ModalChildrenPar) => void
    closeButton?: boolean
}

export type BillingListData = {
    month: string,
    year: number,
    planId: string,
    planTitle: string,
    billingMonthInfos: BillingMonthInfos[]
}

export type BillingMonthInfos = {
    companyId: string,
    companyName: string,
    price: number,
    meetingDate: string
}

export type Match = {
    id: string;
    status: MatchStatus;
    company: Corporate;
    startup: StartUp;
    companyDepartment?: OptionTypes;
    lastMessageDate: string;
    lastMessageText?: string;
    isReadStartup: boolean;
    isReadCompany: boolean;
}
export type StartupAcceptedMatchType = {
    matchId: string,
    acceptedMatch: boolean
}

export type Message = {
    id: string;
    matchId: string;
    dateAval1?: string;
    dateAval2?: string;
    dateAval3?: string;
    dateConfirmed?: string;
    status?: MatchStatus;
    dateAction: string;
    statusDescription?: string;
    sentByStartup: boolean;
    fromSender: boolean
}

export interface ChatMessage extends Message {
    acceptedMatch: boolean,
    isOldMessage: boolean,
    showDate: boolean
}

export type ForgotPWreq = {
    email: string;
    isStartup: boolean,
}

export type ChangeForgotPWreq = {
    email: string,
    password: string,
    isStartup: boolean,
    code: string
    confirmPassword: string
}

export const initialStateModal = {
    isOpen: false,
    type: "",
    title: "",
    message: ""
}

export const initialuserInfo = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: ""
}

export const initialStartUpInfo: StartUpInfo = {
    startUpName: "",
    website: "",
    companyName: "",
    vatNumber: "",
    address: {
        value: "", label: "", isInItaly: false
        // country:"",city:""
    },
    city: {
        value: "",
        label: ""
    },
    sdi: "",
    pec: "",
    state: {
        value: "",
        label: "",
        toValidate: true
    },
    sector: {
        value: "",
        label: ""
    }
}

export const initialResponseInfo = {
    option: {
        value: "",
        label: ""
    },
    termsChecked: false,
    privacyChecked: false
}

export const initialUserCompanyInfo = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: ""
}
export const initialCorporateGuest = {
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    city: {
        value: "",
        label: ""
    }
}

export const initialCorporateInfo: CorporateInfo = {
    companyName: "",
    city: {
        value: "",
        label: ""
    },
    department: {
        value: "",
        label: ""
    },
    level: {
        value: "",
        label: ""
    },
    jobTitle: "",
    termsChecked: false,
    privacyChecked: false
}

export const initialLoginData = {
    user: "",
    password: ""
}

export const initalStartUp: StartUp = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    startUpName: "",
    companyName: "",
    vat: "",
    address: "",
    sdiPec: "",
    state: {
        value: "",
        label: ""
    },
    option: {
        value: "",
        label: ""
    },
    description: "",
    sector: {
        value: "",
        label: ""
    },
    pitch: "",
    tags: [{
        value: "",
        label: ""
    }],
    plan: {
        value: "",
        label: ""
    },
    image: "",
    name: "",
    logoUrl: "",
    imageFile: null,
    logoFile: null,
    currentCounter: {
        id: "",
        startupId: "",
        month: 0,
        year: 0,
        availableMonthMatches: 0,
        confirmedYearMeetings: 0
    }
}




export const initialMessage: Message =
{
    id: "",
    matchId: "",
    dateAval1: "",
    dateAval2: "",
    dateAval3: "",
    dateAction: "",
    statusDescription: "",
    sentByStartup: true,
    fromSender: true
}



export const initialStartUpList: StartUp[] = [initalStartUp]


// SELECT DATE

export enum DatesResponseType {
    respUndefined = 0,
    respLoading = 1,
    respPositive = 2,
    respNegative = -1
}

export interface DatesResponse {
    type: DatesResponseType;
    title: string;
    message: string;
}
export const initialStateDatesResponse = {
    type: 0,
    title: "",
    message: ""
}






export type MatchDate = {
    id: string
    date: string | Date,
}

export const initialMatchDate = {
    id: "",
    date: ""
}


export const initialCorporate: Corporate = {
    id: "",
    name: "",
    users: [],
    city: {
        value: "",
        label: ""
    },
    countUserCompany: 0,
    reasons: [],
    sectors: []
}


